var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSunIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 7.258
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 13.548,
    rx: 1.452
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 21.95,
    y: 3.079,
    rx: 1.452,
    transform: "rotate(45 23.402 5.983)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 25.645,
    y: 12.097,
    rx: 1.452,
    transform: "rotate(90 27.097 15)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 21.95,
    y: 20.499,
    rx: 1.452,
    transform: "rotate(135 23.402 23.402)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 13.548,
    y: 24.194,
    rx: 1.452,
    transform: "rotate(-180 15 27.097)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 4.531,
    y: 20.499,
    rx: 1.452,
    transform: "rotate(-135 5.983 23.402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15c0-.802.65-1.452 1.452-1.452h2.903a1.452 1.452 0 1 1 0 2.903H1.452C.65 16.452 0 15.802 0 15z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.903,
    height: 5.806,
    x: 4.531,
    y: 3.079,
    rx: 1.452,
    transform: "rotate(-45 5.983 5.983)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSunIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sun-icon.a232f9f05e22400f2e7b9c099136744b.svg";